module.exports = __webpack_public_path__ + "static/media/S3N12-4.94d2ae54.svg";